import React, { Fragment } from 'react';
import TestimonialVideoCards from '../../components/site/TestimonialCardStars/TestimonialVideoCards';
import HeroRatings from '../../components/site/HeroRatings/HeroRatings';
import Picture from '../../components/Picture';

import './TestimonialsVideoCardsV5.scss';

const TestimonialsVideoCardsV5 = ({
  industryVersion = false,
  distributorVersion = false,
  showClientLogos = true,
  customTestimonials: passedCustomTestimonials
}) => (
  <section className="ia-testimonial-section container">
    <TestimonialVideoCards
      isHome={!industryVersion && !distributorVersion}
      isAI={industryVersion || distributorVersion}
      noVideo={industryVersion || distributorVersion}
      isDistributor={distributorVersion}
      customTestimonials={passedCustomTestimonials || (industryVersion ? [
        {
          testimonial: <Fragment>"Com o Mercos, os vendedores geram orçamentos e emitem pedidos sem complicação e sem controles manuais. Isso reduz erros, economiza tempo e acaba com a necessidade de levar trabalho para casa, já que o sistema resolve tudo na hora"</Fragment>,
          author: "Mauricio Perin",
          company: "Flach Equipamentos Inteligentes",
          stars: 5,
          img: "mauricio-perin",
          imgAlt: "Mauricio Perin, Flach Equipamentos Inteligentes"
        },
        {
          testimonial: <Fragment>"Hoje, com o Mercos, nosso time comercial fecha vendas e calcula orçamentos em tempo real, com agilidade, sem erros e em um só lugar. Já o time interno foca demandas mais estratégicas, já que não há mais retrabalho na digitação de pedidos"</Fragment>,
          author: "Natália Costa",
          company: "Vouga Decor",
          stars: 5,
          img: "natalia-costa",
          imgAlt: "Natália Costa, Vouga Decor"
        },
        {
          testimonial: <Fragment>"Com o e-commerce B2B, nossos clientes ampliam o mix de compras e nos veem como uma empresa mais atualizada e acessível. Utilizamos a plataforma de forma estratégica e aumentamos vendas, fidelização e a liberdade dos clientes de comprar a qualquer hora"</Fragment>,
          author: "Eduarda Berwanger",
          company: "Berwanger Abrasivos", 
          stars: 5,
          // img: "eduarda-berwanger",
          imgAlt: "Eduarda Berwanger, Berwanger Abrasivos"
        }
      ] : undefined)}
      title={!industryVersion && !distributorVersion ? (
        <span className="testimonials-v5-title">+ 9 mil clientes melhoram a sua operação comercial com a Mercos</span>
      ) : null}
    />

    {/* Show Hero Ratings for industry/distributor version, Client Logos for others */}
    {industryVersion || distributorVersion ? (
      <HeroRatings />
    ) : showClientLogos ? (
      <div className="client-logos-section">
        <div className="client-logos-grid">
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/oakberry.png" alt="Oakberry logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/tagima.png" alt="Tagima logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/mili.png" alt="Mili logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/mtx.png" alt="MTX logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/anasol.png" alt="Anasol logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/berwanger.png" alt="Berwanger logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/maped.png" alt="Maped logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/keune.png" alt="Keune logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/gelopar.png" alt="Gelopar logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/cicero.png" alt="Cicero logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/ftw.png" alt="FTW logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/buffalo.png" alt="Buffalo logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/herbia.png" alt="Herbia logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/beyoung.png" alt="Beyoung logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/alva.png" alt="Alva logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/labotrat.png" alt="Labotrat logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/baggio.png" alt="Baggio logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/la-ganexa.png" alt="La Ganexa logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/dobro.png" alt="Dobro logo" className="client-logo-image" />
          </div>
          <div className="client-logo-item">
            <Picture loading="lazy" src="/images/site/logo-companies/hprime.png" alt="HPrime logo" className="client-logo-image" />
          </div>
        </div>
      </div>
    ) : null}
  </section>
);

export default TestimonialsVideoCardsV5;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Testimonials/TestimonialsVideoCardsV5.jsx